'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
export type MobileContactUsMenuProps = {
  children?: React.ReactNode;
};
export default function MobileContactUsMenu(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function handleClick(event) {
      setAnchorEl(event.currentTarget);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleClick = t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = function handleClose() {
      setAnchorEl(null);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleClose = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IconButton size="large" aria-label="Contact us" aria-controls="menu-appbar" aria-haspopup="true" onClick={handleClick} color="inherit"><MoreVertIcon /></IconButton>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      list: {
        "aria-labelledby": "basic-button"
      }
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== anchorEl || $[5] !== children || $[6] !== open) {
    t5 = <>{t3}<Menu id="basic-menu" anchorEl={anchorEl} open={open} onClose={handleClose} onClick={handleClose} slotProps={t4}>{children}</Menu></>;
    $[4] = anchorEl;
    $[5] = children;
    $[6] = open;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}